import {
    AppPhase,
    DealerAssistTableErrorCode,
    DealingSubPhase,
    FlagStateType,
    NotificationCode,
    NotificationSeverity,
    RouletteSubPhase,
    WorkerAccessLevel
} from './app-enums.model';
import { AppState, GameResultChange, SupervisorState, Worker } from './app-state.model';
import { CardValue } from './cards.enum';
import { ChatMessage as ChatMessageModel } from './chat-message.model';
import { Outcome } from './games.model';

export { TableUpdate as CardDealtEvent } from './app-state.model';

export enum AppEventType {
    CardBurn = 'card-burn',
    CardDealt = 'card-dealt',
    ChatMessage = 'chat-message',
    CutCardDrawn = 'cut-card-drawn',
    FlagStateChange = 'flag-state-change',
    GamePhaseChange = 'game-phase-change',
    GameStateChange = 'game-state-change',
    SupervisorStateChange = 'supervisor-state-change',
    LoginChange = 'login-change',
    Notification = 'notification',
    PlayerCountChange = 'player-count-change',
    // eslint-disable-next-line @typescript-eslint/no-shadow
    GameResultChange = 'game-result-change',
    RoundUntilChange = 'rounds-until-change',
    // eslint-disable-next-line spellcheck/spell-checker
    WorkerRead = 'worker-card-readed',

    RouletteSpeed = 'roulette-speed'
}

export type SupervisorStateChangeEvent = SupervisorState;
export type GameResultChangeEvent = GameResultChange;

export interface LoginChangeEvent {
    old?: Worker;
    new?: Worker;
}

export interface GamePhaseChangeEvent {
    phase: AppPhase;
    subPhase?: DealingSubPhase | RouletteSubPhase;
}

export interface NewRoundPreparationPhaseChangeEvent extends GamePhaseChangeEvent {
    phase: AppPhase.NewRoundPreparation;
    roundId: number;
}

export interface BetsOpenPhaseChangeEvent extends GamePhaseChangeEvent {
    phase: AppPhase.BetsOpen;
    roundId: number;
    subPhase?: RouletteSubPhase;
    data?: {
        timeLeft: number;
        totalTime: number;
    };
}

export interface RoundEndPhaseChangeEvent extends GamePhaseChangeEvent {
    phase: AppPhase.RoundEnd;
    outcome: Outcome;
    outcomes: Outcome[];
}

export interface RoundErrorPhaseChangeEvent extends GamePhaseChangeEvent {
    phase: AppPhase.RoundError;
    errorCode: DealerAssistTableErrorCode;
}

export interface GameStateChangeEvent {
    state: AppState;
}

export interface PlayerCountChangeEvent {
    count: number;
}

export interface CardBurnEvent {
    card: CardValue; // Card that tells us how many card we will need to burn
    burnedCount: number;
    totalToBurnCount: number;
}

export interface FlagStateChangeEvent {
    flag: FlagStateType;
    state: boolean;
}

export interface DealerAssistTableErrorEvent {
    errorCode: DealerAssistTableErrorCode;
    context?: unknown;
}

export interface NotificationEvent {
    code: NotificationCode;
    severity: NotificationSeverity;
    context?: unknown;
}

export enum CountdownType {
    TableClose = 'TableClose',
    GameChange = 'GameChange',
    CroupierLeft = 'CroupierLeft'
}

export interface RoundUntilChange {
    countdownType: CountdownType;
    maxRounds: number;
    roundsRemaining: number;
}

export interface WorkerRead {
    id: string;
    name?: string;
    tableGroups?: string[];
    accessLevel?: WorkerAccessLevel;
}

export type ChatMessageEvent = ChatMessageModel;
